import { AxiosError } from 'axios';
import { useGet } from 'hooks/use-get';
import React, { useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getCalibrations } from 'views/bluviu-nutrition/features/calibrations/api/calibration';
import { CalibrationListItem } from 'views/bluviu-nutrition/features/calibrations/types/calibration-list-item.type';
import { CalibrationsParams } from 'views/bluviu-nutrition/features/calibrations/types/calibrations-params.type';

type State = {
  calibrationsQuery: UseQueryResult<CalibrationListItem[], AxiosError<unknown, any>>;
};

const CalibrationListContext = React.createContext<State | undefined>(undefined);

type CalibrationListProviderProps = {
  children: React.ReactNode;
};

const CALIBRATIONS_STALE_TIME = 1 * 60 * 1000;

const CalibrationListProvider: React.FC<CalibrationListProviderProps> = ({ children }) => {
  const params = useParams<CalibrationsParams>();

  const calibrationsQuery = useGet(
    ['getCalibrations', params.globalSiteId],
    ({ queryKey }) => getCalibrations(String(queryKey[1])),
    {
      enabled: !!params.globalSiteId,
      staleTime: CALIBRATIONS_STALE_TIME,
    }
  );

  return <CalibrationListContext.Provider value={{ calibrationsQuery }}>{children}</CalibrationListContext.Provider>;
};

function useCalibrationListState() {
  const context = useContext(CalibrationListContext);
  if (context === undefined) {
    throw new Error('useCalibrationListState must be used within a CalibrationListProvider');
  }
  return context;
}

export { CalibrationListProvider, useCalibrationListState };